import Stakeholder from '@/stakeholders/entities/stakeholder'
import { Component, Prop, Mixins, Vue, Ref, Watch } from 'vue-property-decorator'
import { Activity } from '@/stakeholders/entities/activity'
import { Attitude } from '@/stakeholders/entities/attitude'
import EditDialogMixin from '@/common/dialogs/mixins/edit-dialog-mixin'
import stakeholdersService from '@/stakeholders/services/stakeholders-service'
import Project from '@/projects/entities/project'

@Component
export default class StakeholderDialog extends Mixins<EditDialogMixin<Stakeholder>>(EditDialogMixin) {

  private activities = [
    { text: 'Aktiv', value: Activity.Active },
    { text: 'Passiv', value: Activity.Passive },
  ]

  private attitudes = [
    { text: 'Positiv', value: Attitude.Positive },
    { text: 'Neutral', value: Attitude.Neutral },
    { text: 'Negativ', value: Attitude.Negative },
  ]

  private projects: Project[] | null = null

  @Watch('dialog')
  private async dialogChanged(newValue: boolean) {
    if (newValue) {
      this.projects = await stakeholdersService.findAllProjectsAsync(this.model.id)
      await this.validate()
    }
  }
}
